/**
 * isiZulu: Tickets
 *
 * What this file covers: The Tickets menu: queue, board, a ticket, tasks, reports and ticket settings.
 *
 * Tone: Calm, professional helpdesk wording. Keep a clear difference between a reply (the client sees it) and a
 * note (only the team sees it). Status names are short.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const tickets: Catalog = {};

export default tickets;
